import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    now: new Date(),
    medication: [],
    reliefs: []
  },
  getters: {
  },
  mutations: {
    setMedicationData: (state, payload) => {
      state.medication = payload;
    },
    setReliefData: (state, payload) => {
      state.reliefs = payload;
    },
  },
  actions: {
    saveMedicationData({ commit }, payload) {
      return new Promise((resolve) => {
        commit("setMedicationData", payload);
        resolve();
      });
    },
    saveReliefData({ commit }, payload) {
      return new Promise((resolve) => {
        commit("setReliefData", payload);
        resolve();
      });
    },
  }
})
